import { ApiService } from "./ApiService";

export class AuthService {
    private readonly apiService: ApiService;

    constructor(apiService: ApiService) {
        this.apiService = apiService;
    }

    public async getConfig(): Promise<unknown> {
        return await this.apiService.getIdentity("account/config");
    }
}
